import { Injectable } from "@angular/core";

import { HeadService } from "@hermes/utils-generic/services/head";

@Injectable()
export class AgecHeadService {
    constructor(private headService: HeadService) {}

    public addMetaTagsAgec(): void {
        this.headService.cleanExistingMetas();

        this.headService.setTitle(
            $localize`:@@hermes.environment.seo.title:Composition de votre produit`,
        );
        this.headService.addNoIndexMetaInformation();
        this.headService.addDescriptionMetaInformations(
            $localize`:@@hermes.environment.seo.metadescription:Découvrez l'empreinte environnementale de votre produit Hermès`,
        );
    }

    public removeMetaTagsAgec(): void {
        this.headService.setDefaultTitle();
        this.headService.removeNoIndexMetaInformation();
        this.headService.cleanDescriptionMetaInformations();
    }
}
